import { t } from "@lingui/macro"

export const KNOWLEDGE_TYPES = [
    {
        value: "file",
        get label() {
            return t`knowledge-item-modal.type-file`
        },
    },
    {
        value: "page",
        get label() {
            return t`knowledge-item-modal.type-page`
        },
    },
    {
        value: "web",
        get label() {
            return t`knowledge-item-modal.type-web-search`
        },
    },
]
